import axios from "../utils/axiosConfig";

const articleService = {
    getAll: async (params = {}) => {
        params.select = params.select || 'title,section,author,status,publishedAt';
        const response = await axios.get("/articles/all", { params });
        return response.data;
    },

    getById: async (id) => {
        const response = await axios.get(`/articles/${id}`);
        return response.data;
    },

    create: async (data) => {
        return axios.post("/articles", data);
    },

    update: async (id, data) => {
        return axios.put(`/articles/${id}`, data);
    },

    delete: async (id) => {
        return axios.delete(`/articles/${id}`);
    },

    changeStatus: async (id, data) => {
        return axios.patch(`/articles/${id}`, data);
    },

    getStats: async () => {
        const response = await axios.get("/articles/stats");
        return response.data;
    }
};

export default articleService;
